import React from "react";
import { useTranslation } from "react-i18next";
import { icDeleteRed, icQuestion } from "../../components/image/image-src";
import { OkCancelPopup } from "../../components/modal/OkCancelPopup";
import { UiTitle } from "../../components/text/UiTitle";
import CartItemRow from "./components/CartItemRow";
import FormBookOrderProduct from "./components/FormBookOrderProduct";
import { useShoppingCart } from "./useShoppingCart";
import Icon from "../../components/image/Icon";
import { CartEmptyMesg } from "../../components/CartEmptyMesg";
import { useOrderProduct } from "./useOrderProduct";

interface Item {
  id: number;
  title: string;
  description: string;
  additional: string;
  time: string;
  adultCount: number;
  adultPrice: number;
  childCount: number;
  childPrice: number;
  voucherAmount: number;
  total: number;
}

const OrderProduct: React.FC = () => {
  const jj = useOrderProduct();
  const shoppingCart = useShoppingCart();
  const { t } = useTranslation();

  return (
    <>
      <div className="ui-container cart-one relative items-center justify-center pt-4 sm:py-[2.5rem]">
        <div className="flex flex-col self-center">
          <div className="mb-10 flex items-baseline justify-between gap-5">
            <UiTitle text={t("Ordered Product")} className="shrink-0" />
            <CartTop shoppingCart={shoppingCart} />
          </div>
          <div className="flex flex-col items-start gap-[1.50rem] lg:flex-row">
            {/* Additional content can go here */}
            <div className="flex w-full flex-1 flex-col gap-[1.50rem]">
              {jj.cartItems.map((card) => (
                <CartItemRow
                  key={card.id}
                  voucherId={jj?.voucherId}
                  bookingState={card}
                  onSelectItem={shoppingCart.onSelectItem}
                  setDelSingle={shoppingCart.setDelSingle}
                  vari={"READONLY"}
                />
              ))}
            </div>

            {/* Additional content can go here */}
            {!!jj.cartItems.length && <FormBookOrderProduct {...jj} />}
          </div>
          {!jj.cartItems.length && (
            <div>
              <CartEmptyMesg />
            </div>
          )}
        </div>
      </div>

      {shoppingCart.popupDel.isOpen && (
        <OkCancelPopup
          ic={icQuestion}
          title={t("Are you sure want to remove?")}
          onOk={() => shoppingCart.popupDel.onOk()}
          onCancel={() => shoppingCart.popupDel.close()}
          okText={t("Delete")}
        />
      )}
    </>
  );
};

export default OrderProduct;

export const CartTop = ({
  shoppingCart,
}: {
  shoppingCart: ReturnType<typeof useShoppingCart>;
}) => {
  const { t } = useTranslation();
  const checkedItems = shoppingCart.items.filter((card) => card.checked);
  return (
    <div className="flex w-full items-center bg-white">
      <div className="flex w-full items-center gap-4">
        {/* <input
          id="selectAllItem"
          className="custom-checkbox"
          type="checkbox"
          checked={shoppingCart.items.every((card) => card.checked)}
          onChange={(event) =>
            shoppingCart.onSelectAll(event.currentTarget.checked)
          }
        /> */}
        {/* <label
          htmlFor="selectAllItem"
          className="cursor-pointer text-base font-semibold leading-[1.3619rem] text-[#232323]"
        >
          {t("Select All")}
        </label> */}

        {!!checkedItems.length && (
          <label className="cursor-pointer text-[1.25rem] font-normal text-[#232323]">
            {t("Total ")} ({checkedItems.length})
          </label>
        )}

        <button
          type="button"
          className="ml-auto hidden text-base font-normal leading-[1.25rem] text-[#DA3838] sm:flex sm:items-center sm:gap-1"
          onClick={shoppingCart.onRemoveItems}
        >
          <Icon className="-mt-0.5" src={icDeleteRed} />
          {t("Empty cart2")}
        </button>
      </div>
    </div>
  );
};
